import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { SeoLink, ALWAYS_LINKABLE_LINK } from 'dibs-elements/exports/SeoLink';

import styles from './GridHeader.scss';

type Props = {
    title: ReactNode;
    href?: string;
    dataTn: string;
};
export const GridHeader: FC<Props> = ({ title, href, dataTn }) => (
    <div className={styles.wrapper}>
        <div className={styles.header}>{title}</div>
        {href && (
            <SeoLink
                className={styles.link}
                variant={ALWAYS_LINKABLE_LINK}
                linkData={{ path: href, isLinkable: false }}
                dataTn={dataTn}
            >
                <FormattedMessage id="GridHeader.viewAll" defaultMessage="View All" />
            </SeoLink>
        )}
    </div>
);
